/**
 * Inhaltsleiste der Textseiten (R8.6): baut „Auf dieser Seite“ neben dem Inhalt ([data-toc])
 * aus der höchsten Überschriftenebene, die mindestens 3-mal vorkommt (H2, sonst H3). Überschriften
 * in Akkordeons und Tabs zählen nicht. Fehlende ids werden gesetzt, der Abschnitt, der gerade
 * gelesen wird, ist markiert. Ohne JavaScript gibt es keine Leiste, der Text bleibt vollständig.
 * Die Leiste zeigt das CSS erst ab 64em (.l-textpage > .c-toc).
 */
const MIN_HEADINGS = 3;

const slug = (text) => text.toLowerCase()
  .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
  .slice(0, 60) || 'abschnitt';

function ensureId(heading) {
  if (heading.id) return heading.id;
  const base = slug(heading.textContent);
  let id = base;
  for (let n = 2; document.getElementById(id); n++) id = `${base}-${n}`;
  heading.id = id;
  return id;
}

function headingsOf(content) {
  for (const level of ['h2', 'h3']) {
    const headings = [...content.querySelectorAll(level)]
      .filter((h) => !h.closest('details, .c-tabs') && h.textContent.trim() !== '');
    if (headings.length >= MIN_HEADINGS) return headings;
  }
  return [];
}

function buildToc(content) {
  const headings = headingsOf(content);
  if (!headings.length) return null;
  const toc = document.createElement('nav');
  toc.className = 'c-toc';
  toc.setAttribute('aria-label', 'Auf dieser Seite');
  const label = document.createElement('p');
  label.className = 'c-label';
  label.textContent = 'Auf dieser Seite';
  toc.append(label);
  for (const heading of headings) {
    const link = document.createElement('a');
    link.href = `#${ensureId(heading)}`;
    link.textContent = heading.textContent.trim().replace(/\s+/g, ' ');
    toc.append(link);
  }
  content.after(toc);
  return toc;
}

/** Markiert den Abschnitt, der gerade gelesen wird. */
function observe(toc) {
  if (!('IntersectionObserver' in window)) return;
  const links = [...toc.querySelectorAll('a[href^="#"]')];
  const map = new Map(links.map((a) => [document.getElementById(decodeURIComponent(a.hash.slice(1))), a]).filter(([el]) => el));
  const observer = new IntersectionObserver((entries) => {
    const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
    if (!visible) return;
    links.forEach((a) => a.removeAttribute('aria-current'));
    map.get(visible.target)?.setAttribute('aria-current', 'true');
  }, { rootMargin: '-20% 0px -70% 0px' });
  map.forEach((_, el) => observer.observe(el));
}

export function initToc() {
  const content = document.querySelector('[data-toc]');
  const toc = content && buildToc(content);
  if (toc) observe(toc);
}
